import { Check, Sparkles } from "lucide-react";
import { PLANS } from "@/lib/constants";

export const PlanCards = ({ currentPlan, onSelect, ctaLabel, loadingPlan, discount }) => (
  <div className="grid gap-5 md:grid-cols-3">
    {PLANS.map((p) => {
      const current = currentPlan === p.id;
      return (
        <div
          key={p.id}
          data-testid={`plan-card-${p.id}`}
          className={`card-flat card-hover flex flex-col p-7 ${p.highlight ? "beam-border border-transparent" : ""}`}
        >
          <div className="flex items-center justify-between">
            <h3 className="font-display text-xl font-bold">{p.name}</h3>
            {p.highlight && (
              <span className="inline-flex items-center gap-1 rounded-full bg-brand px-2.5 py-1 text-[11px] font-semibold text-white">
                <Sparkles className="h-3 w-3" /> Le plus complet
              </span>
            )}
            {p.id === "premium" && !p.highlight && (
              <span className="rounded-full bg-accent px-2.5 py-1 text-[11px] font-semibold text-accent-foreground">Populaire</span>
            )}
          </div>
          <div className="mt-5 flex items-baseline gap-1.5">
            {discount && p.amount ? (
              <>
                <span className="font-display text-4xl font-extrabold tracking-tight" data-testid={`plan-student-price-${p.id}`}>{(Math.round(p.amount * (1 - discount) * 100) / 100).toFixed(2).replace(".", ",")} €</span>
                <span className="text-sm text-muted-foreground line-through">{p.price}</span>
              </>
            ) : <span className="font-display text-4xl font-extrabold tracking-tight">{p.price}</span>}
            <span className="text-sm text-muted-foreground">{p.period}</span>
          </div>
          <ul className="mt-6 flex-1 space-y-3 text-sm">
            {p.features.map((f) => (
              <li key={f} className="flex gap-2.5">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <span>{f}</span>
              </li>
            ))}
          </ul>
          <button
            data-testid={`plan-select-${p.id}`}
            disabled={current || loadingPlan === p.id || (currentPlan && p.id === "free")}
            onClick={() => onSelect(p.id)}
            className={`mt-8 rounded-full px-5 py-3 text-sm font-semibold transition-[transform,opacity,background-color] duration-200 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60 ${
              p.highlight || p.id === "premium" ? "bg-brand text-white hover:opacity-90" : "border bg-background hover:bg-muted"
            }`}
          >
            {current ? "Offre actuelle" : loadingPlan === p.id ? "Redirection…" : ctaLabel(p)}
          </button>
        </div>
      );
    })}
  </div>
);
